/* Shopify server-rendered exact selection; no full variant array or cart AJAX. */
(() => {
  'use strict';
  if (window.__pdsDraperyMaster) return;
  window.__pdsDraperyMaster = true;
  let sequence = 0, controller, submitted = false;
  const fields = p => [...p.querySelectorAll('[data-high-option]')];
  const enabled = p => p.dataset.commerce === 'true' && document.body.dataset.commerce === 'true';
  // Color photographs are verified media, not evidence of a valid purchasable tuple.
  function previewColor(p) {
    const gallery = p.querySelector('.gallery'), anchor = p.querySelector('[data-high-photo]');
    const image = anchor?.querySelector('img'), label = p.querySelector('[data-high-photo-state]');
    if (!gallery || !anchor || !image) return;
    const choice = p.querySelector('[data-high-color]')?.selectedOptions[0];
    const color = choice?.value ? choice.dataset.colorName : '';
    try {
      const prices = JSON.parse(p.querySelector('[data-high-color-prices]')?.textContent || '{}');
      const amount = prices.colors?.[color]?.minCents || prices.productMin;
      if (Number.isFinite(amount) && amount > 0) {
        p.dataset.startingCents = String(amount);
        if (!p.dataset.selectedId || p.dataset.resolved === 'false') {
          const money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:window.Shopify?.currency?.active || 'USD'}).format(amount / 100);
          p.querySelector('[data-high-price]').textContent = 'From ' + money + ' per panel';
        }
      }
    } catch (_) { /* Original native price stays authoritative if data is absent. */ }
    let photo;
    try {
      const map = JSON.parse(p.querySelector('[data-high-color-photos]')?.textContent || '{}');
      if (map.productId === p.dataset.productId && color && Object.hasOwn(map.photos || {}, color)) photo = map.photos[color];
    } catch (_) { /* Missing/broken mapping must never show a different color. */ }
    if (!color) {
      try {
        const fallback = JSON.parse(p.querySelector('[data-high-default-photo]')?.textContent || '{}');
        if (fallback.productId === p.dataset.productId && fallback.src) {
          const map = JSON.parse(p.querySelector('[data-high-color-photos]')?.textContent || '{}');
          const match = map.productId === p.dataset.productId && Object.values(map.photos || {}).find(entry => String(entry.mediaId) === String(fallback.mediaId));
          if (match?.alt) fallback.alt = match.alt;
          photo = fallback;
        }
      } catch (_) { /* No unverified substitute. */ }
    }
    gallery.hidden = !photo;
    if (!photo) {
      anchor.hidden = true; delete gallery.dataset.previewColor;
      image.removeAttribute('src'); image.removeAttribute('srcset'); anchor.removeAttribute('href');
      if (label) label.textContent = color ? 'Photograph unavailable.' : 'Choose a color to see its photograph.';
      return;
    }
    // Set every responsive source, intrinsic dimensions and accessible label together.
    anchor.hidden = false; anchor.href = photo.href; anchor.dataset.mediaId = photo.mediaId;
    anchor.setAttribute('aria-label', 'Enlarge ' + photo.alt);
    image.alt = photo.alt; image.width = photo.width; image.height = photo.height;
    image.srcset = photo.srcset; image.src = photo.src;
    gallery.dataset.previewColor = color;
    p.querySelectorAll('[data-gallery-photo]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.mediaId === photo.mediaId)));
    if (label) label.textContent = color ? color + ' color photograph.' : 'Representative product photograph — ' + photo.alt + '. Choose a color to preview it.';
  }
  function close(p, message) {
    p.dataset.resolved = 'false';
    const id = p.querySelector('[name="id"]');
    if (id) { id.value = ''; id.disabled = true; }
    p.querySelector('[data-high-add]').disabled = true;
    p.querySelector('[name="quantity"]').disabled = true;
    p.querySelector('[data-high-price]').textContent = 'Price pending selection.';
    p.querySelector('[data-high-sku]').textContent = 'SKU: choose options';
    previewColor(p);
    p.querySelector('[data-high-state]').textContent = message;
  }
  // Validate URL intent against Shopify's returned IDs, never a fallback first variant.
  function confirmsSelection(p, selectionUrl) {
    const url = new URL(selectionUrl, location.href), controls = fields(p);
    if (p.dataset.optionCount !== '2' || controls.length !== 2) return false;
    if (url.searchParams.has('variant')) {
      const requested = url.searchParams.getAll('variant');
      if (requested.length !== 1 || !/^\d+$/.test(requested[0]) || requested[0] !== p.dataset.selectedId) return false;
    }
    if (url.searchParams.has('option_values')) {
      const requested = url.searchParams.getAll('option_values');
      const ids = requested[0].split(',');
      if (requested.length !== 1 || ids.length !== 2 || ids.some((id,i) => !/^\d+$/.test(id) || controls[i].value !== id)) return false;
    }
    return true;
  }
  function initialize(p, selectionUrl = location.href) {
    const url = new URL(selectionUrl, location.href);
    if (!confirmsSelection(p, selectionUrl)) {
      fields(p).forEach(f => { f.value = ''; });
      p.dataset.selectedId = ''; p.dataset.available = 'false';
      close(p, 'This saved configuration is no longer available. Please reselect color and panel height.');
      p.querySelector('[data-high-add]').textContent = 'Choose options';
      const recovery = new URL(p.dataset.productUrl, location.href);
      const preview = url.searchParams.get('preview_theme_id');
      if (preview) recovery.searchParams.set('preview_theme_id', preview);
      p.querySelector('[data-high-reload]').href = recovery.href;
      p.querySelector('[data-high-reload]').textContent = 'Reselect color and panel height';
      return;
    }
    if (!url.searchParams.has('variant') && !url.searchParams.has('option_values')) {
      const color = p.querySelector('[data-high-color]'), requested = url.searchParams.get('pds_color');
      const match = color && [...color.options].find(o => o.value === requested && /^\d+$/.test(o.value));
      if (match) {
        fields(p).forEach(f => { f.value = f === color ? match.value : ''; });
        p.dataset.selectedId = ''; p.dataset.available = 'false';
      }
    }
    previewColor(p);
    const id = p.querySelector('[name="id"]'), q = p.querySelector('[name="quantity"]');
    const valid = /^\d+$/.test(p.dataset.selectedId || '') && id.value === p.dataset.selectedId && fields(p).length === 2 && fields(p).every(f => /^\d+$/.test(f.value));
    p.dataset.resolved = String(valid);
    if (!valid) { id.value = ''; id.disabled = true; q.disabled = true; }
    const add = p.querySelector('[data-high-add]');
    add.disabled = !valid || !enabled(p) || p.dataset.available !== 'true' || !q.checkValidity() || submitted;
    add.textContent = !valid ? 'Choose options' : p.dataset.available !== 'true' ? 'Sold out' : enabled(p) ? 'Add to cart' : 'Unavailable';
  }
  async function render(p, url, ids, focusPosition, push) {
    const token = ++sequence;
    if (controller) controller.abort();
    controller = new AbortController();
    const signal = controller.signal;
    const timeout = setTimeout(() => controller?.signal === signal && controller.abort(), 12000);
    const nativeUrl = new URL(url);
    nativeUrl.searchParams.delete('section_id');
    nativeUrl.searchParams.delete('sections');
    const reload = p.querySelector('[data-high-reload]'); reload.href = nativeUrl.href;
    close(p, 'Loading exact configuration…');
    p.setAttribute('aria-busy', 'true');
    try {
      const request = new URL(nativeUrl); request.searchParams.set('section_id', p.dataset.sectionId);
      const response = await fetch(request.href, {signal, headers: {Accept: 'text/html'}});
      if (!response.ok || response.redirected) throw Error('Product selection could not be loaded.');
      const html = await response.text();
      if (token !== sequence || signal.aborted || !p.isConnected) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const next = doc.querySelector('[data-high-product]');
      if (!next || next.dataset.sectionId !== p.dataset.sectionId || next.dataset.productId !== p.dataset.productId) throw Error('Unexpected product response.');
      if (!confirmsSelection(next, nativeUrl.href)) throw Error('This saved configuration is no longer available. Please reselect color and panel height.');
      const nextFields = fields(next);
      if (ids && (nextFields.length !== ids.length || nextFields.some((f, i) => f.value !== ids[i]))) throw Error('Option selection was not confirmed.');
      const id = next.querySelector('[name="id"]');
      if (!id || id.value !== next.dataset.selectedId || (id.value && !/^\d+$/.test(id.value))) throw Error('Variant selection was not confirmed.');
      if (next.dataset.commerce !== p.dataset.commerce) throw Error('Catalog mode changed. Reload the product.');
      if (!next.querySelector('[name="quantity"]') || !next.querySelector('[data-high-add]') || !next.querySelector('[data-high-form]')) throw Error('Incomplete product response.');
      // Keep the requested option IDs even for a nonexistent combination; never substitute a first variant.
      if (id.value) nativeUrl.searchParams.set('variant', id.value);
      else nativeUrl.searchParams.delete('variant');
      next.querySelector('[data-high-reload]').href = nativeUrl.href;
      initialize(next, nativeUrl.href);
      p.replaceWith(next);
      if (push && nativeUrl.href !== location.href) history.pushState({pdsHigh: true}, '', nativeUrl);
      const target = nextFields.find(f => f.dataset.position === focusPosition);
      if (target) target.focus({preventScroll: true});

    } catch (error) {
      if (token !== sequence || !p.isConnected) return;
      close(p, 'Please reload your selection.');
      p.querySelector('[data-high-error]').textContent = 'Could not update your selection. Please reload.';
    } finally {
      clearTimeout(timeout);
      if (token === sequence && p.isConnected) p.removeAttribute('aria-busy');
    }
  }
  document.addEventListener('change', event => {
    const p = event.target.closest('[data-high-product]'); if (!p || submitted) return;
    if (event.target.matches('[name="quantity"]')) { initialize(p); return; }
    if (!event.target.matches('[data-high-option]')) return;
    const ids = fields(p).map(f => f.value);
    if (p.dataset.optionCount !== '2') { close(p, 'Options are being updated. Please reload before selecting.'); return; }
    if (ids.length !== 2 || !ids.every(id => /^\d+$/.test(id))) {
      ++sequence; controller?.abort();
      const url = new URL(location.href), color = p.querySelector('[data-high-color]')?.value;
      ['variant', 'option_values', 'selling_plan'].forEach(k => url.searchParams.delete(k));
      if (/^\d+$/.test(color || '')) url.searchParams.set('pds_color', color); else url.searchParams.delete('pds_color');
      if (url.href !== location.href) history.pushState({pdsHigh:true}, '', url);
      close(p, 'Choose every option.'); return;
    }
    const selected = event.target.selectedOptions[0];
    const url = new URL(location.href);
    const sibling = selected.dataset.productUrl;
    if (sibling && new URL(sibling, location.href).pathname !== new URL(p.dataset.productUrl, location.href).pathname) {
      close(p, 'Opening selected product…'); const target = new URL(sibling, location.href);
      if (target.origin !== location.origin) return;
      const preview = url.searchParams.get('preview_theme_id'); if (preview) target.searchParams.set('preview_theme_id', preview);
      location.assign(target.href); return;
    }
    url.searchParams.delete('variant'); url.searchParams.delete('selling_plan');
    url.searchParams.set('option_values', ids.join(','));
    render(p, url, ids, event.target.dataset.position, true);
  });
  document.addEventListener('error', event => {
    if (!(event.target instanceof HTMLImageElement) || !event.target.closest('[data-high-photo]')) return;
    const p = event.target.closest('[data-high-product]'); if (!p) return;
    event.target.closest('.gallery').hidden = true;
    const label = p.querySelector('[data-high-photo-state]');
    if (label) label.textContent = 'Photograph could not load.';
  }, true);
  document.addEventListener('submit', event => {
    const form = event.target.closest('[data-high-form]'); if (!form) return;
    const p = form.closest('[data-high-product]'), id = form.querySelector('[name="id"]'), q = form.querySelector('[name="quantity"]');
    if (submitted || p.dataset.resolved !== 'true' || !enabled(p) || p.dataset.available !== 'true' || !id.value || id.disabled || id.value !== p.dataset.selectedId || !form.checkValidity() || q.disabled) { event.preventDefault(); return; }
    // Normal native POST. Lock before a second tap; do not disable successful form fields.
    submitted = true; p.querySelector('[data-high-add]').disabled = true;
    fields(p).forEach(f => f.disabled = true);
    p.querySelector('[data-high-state]').textContent = 'Submitting to Shopify. Do not submit again; check your cart if navigation is interrupted.';
  });
  window.addEventListener('popstate', () => {
    const p = document.querySelector('[data-high-product]'); if (!p) return;
    const url = new URL(location.href), values = url.searchParams.get('option_values');
    if (values) url.searchParams.delete('variant');
    render(p, url, values ? values.split(',') : null, null, false);
  });
  window.addEventListener('pageshow', event => { if (event.persisted) location.reload(); });
  document.querySelectorAll('[data-high-product]').forEach(p => initialize(p));
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-high-product]').forEach(p => initialize(p)));
})();
